'use client';

import { useState } from 'react';
import { ChevronDown, ShieldCheck } from 'lucide-react';

import styles from '@/app/[locale]/ai-model/ai-models.module.css';

type FaqItem = {
  question: string;
  answer: string;
};

export default function ModelFaq({ items, sourceNote }: { items: FaqItem[]; sourceNote: string }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      <div className={styles.faqList}>
        {items.map((item, index) => {
          const isOpen = openIndex === index;
          const answerId = `model-faq-answer-${index}`;
          return (
            <article className={isOpen ? styles.faqItemOpen : styles.faqItem} key={item.question}>
              <h3>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={answerId}
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  <span>{item.question}</span>
                  <span className={styles.faqToggle} aria-hidden="true"><ChevronDown /></span>
                </button>
              </h3>
              {isOpen && <div className={styles.faqAnswer} id={answerId}><p>{item.answer}</p></div>}
            </article>
          );
        })}
      </div>
      <p className={styles.faqSourceNote}><ShieldCheck aria-hidden="true" /> {sourceNote}</p>
    </>
  );
}
